import _ from 'lodash'
import i18n from '@/i18n'
import { mapMutations } from 'vuex'
export default {
  filters: {
    starsTag: stars => {
      let result = []
      _.forEach(stars, o => {
        const starsMap = {
          '0': i18n.t('unit.star', [i18n.t('number')[0]]),
          '1': i18n.t('unit.star', [i18n.t('number')[1]]),
          '2': i18n.t('unit.star', [i18n.t('number')[2]]),
          '3': i18n.t('unit.star', [i18n.t('number')[3]]),
          '4': i18n.t('unit.star', [i18n.t('number')[4]]),
          '5': i18n.t('unit.star', [i18n.t('number')[5]])
        }
        result.push(starsMap[o])
      })
      return result.join(', ')
    },
    dateRangeTag: date => {
      return date.join(' ~ ')
    }
  },
  methods: {
    ...mapMutations([
      'search/REMOVE_FILTERS_HOTEL_TYPES',
      'search/REMOVE_FILTERS_FEATURES'
    ]),
    removeTag: function (group, target) {
      const groups = {
        hotelType: () => {
          this['search/REMOVE_FILTERS_HOTEL_TYPES'](target)
        },
        feature: () => {
          this['search/REMOVE_FILTERS_FEATURES'](target)
        }
      }
      groups[group](target)
    },
    mapSearch: function (val) {
      let result = []
      if (val.subject) {
        result.push(val.subject)
      }
      if (val.text) {
        result.push(val.text)
      }
      return result.join(', ')
    },
    mapHotelType: function (type) {
      const matchItem = _.find(this.options.hotelType.items, item => {
        return item.key === type
      })
      return matchItem.name
    },
    parsePriceRange: function (price) {
      const min = this.$options.filters.currencySign() + this.$options.filters.toCurrency(price[0])
      const max = this.$options.filters.currencySign() + this.$options.filters.toCurrency(price[1])
      return `${min} ~ ${max}`
    },
    mapFeature: function (feature) {
      let result = null
      _.forEach(this.options.features.items, group => {
        _.forEach(group, item => {
          if (item.key === feature) {
            result = item
          }
        })
      })
      return result.name
    }
  }
}
